import { defineComponent as _defineComponent } from 'vue'
import { computed, shallowRef } from 'vue'
import {
  loadLicenseSuggestIndex,
  recommendLicenses,
  type LicenseSuggestIndex
} from '@/utils/format-edit/licenseSuggest'


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseRecommendChips',
  props: {
    entered: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({ (e: 'select', text: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** 入力済みの免許・資格（これらはおすすめから外す） */
  entered: string[]
};





const index = shallowRef<LicenseSuggestIndex | null>(null)
loadLicenseSuggestIndex()
  .then((loaded) => {
    index.value = loaded
  })
  .catch(() => {})

const chips = computed(() =>
  index.value ? recommendLicenses(index.value, props.entered) : []
)

return { __sfc: true,props, emit, index, chips }
}

})